import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule, NbTabsetModule } from '@nebular/theme';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

import { KPI } from '../../../@core/api';
import { UtilsService } from '../../../@core/utils';
import { ThousandsSeparatorPipe } from '../../pipes/thousands-separator.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';

export interface MappedEnvironmentalProfile extends KPI.EnvironmentalProfile {
  tabName: string;
  total_emissions: number;
  embodied_emissions: number;
  operational_emissions: number;
  yearly_embodied_emissions: string;
}

@Component({
  selector: 'app-environmental-profiles-dialog',
  styleUrls: ['./environmental-profiles-dialog.component.scss'],
  templateUrl: './environmental-profiles-dialog.component.html',
  standalone: true,
  imports: [
    NbCardModule,
    NbTabsetModule,
    FontAwesomeModule,
    DatePipe,
    TranslateModule,
    ThousandsSeparatorPipe
  ],
})
export class EnvironmentalProfilesDialogComponent implements OnInit {
  public assetType: KPI.AssetType = null;
  public environmentalProfiles: KPI.EnvironmentalProfile[] = [];
  public mappedEnvironmentalProfiles: MappedEnvironmentalProfile[] = [];

  constructor(
    private ref: NbDialogRef<EnvironmentalProfilesDialogComponent>,
    private translate: TranslateService,
    private utilsService: UtilsService,
  ) { }

  public ngOnInit(): void {
    this.mappedEnvironmentalProfiles = this.environmentalProfiles.map(profile => {

      const embodied_emissions = profile.production_emissions
        + profile.transport_emissions
        + profile.maintenance_emissions
        + profile.end_of_life_emissions;

      return {
        ...profile,
        tabName: profile.is_default
          ? profile.reporting_organization
          + ' ('
          + this.translate.instant('Default profile')
          + ')'
          : profile.reporting_organization,
        total_emissions: profile.production_emissions
          + profile.transport_emissions
          + profile.life_emissions
          + profile.maintenance_emissions
          + profile.end_of_life_emissions,
        embodied_emissions,
        yearly_embodied_emissions: this.assetType?.expected_duration
          ? this.utilsService.formateNumber(
            Math.round(embodied_emissions / this.assetType.expected_duration)
          )
          : '0',
        operational_emissions: profile.life_emissions,
      };

    }).sort((a, b) => (a.is_default === b.is_default) ? 0 : a.is_default ? -1 : 1);
  }


  public submit(): void {
    this.ref.close();
  }

}
